import { Component, OnInit } from '@angular/core';
import { ProductService } from 'src/app/shared/services/product.service';
import { ProductoIndividualService } from 'src/app/shared/services/producto-individual.service';
import { IMapaRentabilidad } from 'src/app/shared/Entities/productoIndividual.entities';
import * as html2pdf from 'html2pdf.js';
import * as jsPDF from 'jspdf';
import { AppInsightsService } from 'src/app/shared/services/app-insights-service';
import { Event } from 'src/app/shared/enums/insights/event';

@Component({
  selector: 'app-informe-rentabilidad',
  templateUrl: './informe-rentabilidad.component.html',
  styleUrls: ['./informe-rentabilidad.component.sass'],
})
export class InformeRentabilidadComponent implements OnInit {
  loadingTable: boolean;
  public itemcount = 4;
  mensajeRespuesta: string;

  public FechaMesCerrado: any;
  data: IMapaRentabilidad;
  s: any;
  loading = false;

  constructor(
    private servicio: ProductoIndividualService,
    private appInsightsService: AppInsightsService
  ) {
    this.loadingTable = true;
    this.obtenerMapaRentabilidad();
  }
  ngOnInit() {}

  obtenerMapaRentabilidad() {
    this.servicio.obtenerMapaRentabilidad().subscribe(
      result => {
        this.loadingTable = true;
        this.data = result;
        this.setFlag(this.data);
        this.FechaMesCerrado = this.data.MesCerradoMapa;
        this.loadingTable = false;
      },
      error => {
        this.loadingTable = false;
      }
    );
  }

  setFlag(data) {
    let value = false;
    data.Administrador.forEach(admin => {
      admin.ListadoRiesgo.forEach(riesgo => {
        riesgo.ListadoAgrupacion.forEach(agrupacion => {
          value = !value;
          agrupacion.FLAG = value;
        });
      });
    });
  }

  // 5417 - bipinza - INICIO
  onExportClick(s): void {
    this.appInsightsService.trackEvent(Event.btnDownloadProfitability);
    const fecha = new Date();
    const dd = fecha.getDate();
    const mm = fecha.getMonth() + 1;
    const yy = fecha.getFullYear();

    let dd_new = dd.toString();
    if (dd < 10) {
      dd_new = '0' + dd;
    }

    let mm_new = mm.toString();
    if (mm < 10) {
      mm_new = '0' + mm;
    }

    const fechaHoy = dd_new + ' / ' + mm_new + ' / ' + yy.toString();

    const logo = new Image();
    logo.src = '../../../../../assets/logos/Logo_VidaSecurity.png';
    const t = new Image();
    t.src = '../../../../../assets/img/title.png';
    const f = new Image();
    f.src = '../../../../../assets/img/fecha.png';

    const opt = {
      margin: [0, 10, 10, 10], //top, left, buttom, right
      filename: 'RentabilidadSP.pdf',
      image: { type: 'jpeg', quality: 1 },
      html2canvas: {
        height: 3900,
        y: -190,
        scrollY: 0,
        removeContainer: true,
        scale: 1.5,
      },
      jsPDF: { unit: 'mm', format: 'letter', orientation: 'p' },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
    };
    var i;
    const content: Element = document.getElementById('element-to-export');

    if ((s = true)) {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 3000);
    } else {
      this.loading = false;
    }

    html2pdf()
      .from(content)
      .set(opt)
      .toPdf()
      .get('pdf')
      .then(function(pdf) {
        var totalPages = pdf.internal.getNumberOfPages();
        let x = 30;
        let y = 30;

        for (i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.addImage(logo, 'JPEG', x - 20, y - 20, 63, 9, undefined, 'FAST');
          pdf.addImage(f, 'JPEG', 161, y - 20, 23, 6, undefined, 'FAST');
          pdf.setTextColor(35, 33, 114);
          pdf.setFontSize(8);
          pdf.text(fechaHoy, 185, y - 16);
        }

        pdf.setPage(1);
        pdf.addImage(t, 'JPEG', x - 19, y, 194, 15, undefined, 'FAST');
      })
      .save();
  }
  // 5417 - FIN
}
